import React from 'react';

function PageToggleBanner({ label, enabled, onToggle }) {
  return (
    <div className="page-toggle-banner">
      <span>{label}</span>
      <div className={`pill-toggle${enabled ? ' on' : ''}`} onClick={onToggle}>
        <div className="pill-toggle-knob" />
      </div>
    </div>
  );
}

export default PageToggleBanner;
